var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "px-sm-0 px-2" },
    [
      _c(
        "v-btn",
        {
          attrs: {
            block: "",
            loading: _vm.loading,
            disabled: _vm.loading,
            color: "primary",
            depressed: "",
            tile: "",
            large: ""
          },
          on: {
            click: function($event) {
              return _vm.submit($event)
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("checkout.placeOrder")))]
      ),
      _c("p", { staticClass: "caption mt-2" }, [
        _vm._v(_vm._s(_vm.$t("checkout.privacyPolicyAgreementText"))),
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: _vm.$t("footer.privacyPolicyPdf")
            },
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("checkout.privacyPolicyAgreementLink")))]
        ),
        _vm._v(".")
      ]),
      _c("v-checkbox", {
        attrs: { label: _vm.$t("checkout.marketingAgreement") },
        model: {
          value: _vm.form.marketingAgreement,
          callback: function($$v) {
            _vm.$set(_vm.form, "marketingAgreement", $$v)
          },
          expression: "form.marketingAgreement"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }